import type { Mutation, Query } from '@tanstack/react-query';

import type { GenericFailure } from '@playq/services-shared';

import { logSnackbarError, snackbarService } from '/common/snackbarService';

import type { IOnErrorMessageCallback } from './types';

export const onErrorHandle = ({
  error,
  query,
}: {
  error: GenericFailure;
  query: Query<unknown, unknown, unknown> | Mutation<unknown, unknown>;
}) => {
  const { meta } = query ?? {};
  const { onErrorMessage, logOnError, onError } = meta ?? {};

  let messageToShow: string | undefined;
  let shouldLog = logOnError === true;

  if (typeof onErrorMessage === 'function') {
    const result = (onErrorMessage as IOnErrorMessageCallback)(error);

    if (typeof result === 'string') {
      messageToShow = result;
    } else if (typeof result === 'object' && result !== null) {
      messageToShow = result.message;
      if (result.log === true) {
        shouldLog = true;
      }
    }
  } else if (typeof onErrorMessage === 'string') {
    messageToShow = onErrorMessage;
  }

  if (messageToShow) {
    snackbarService.error(messageToShow);
  }

  if (shouldLog) {
    console.error(error);
    return;
  }

  if (onError !== undefined) {
    (onError as (error: GenericFailure, source: typeof query) => void)(error, query);
    return;
  }

  if (messageToShow === undefined) {
    logSnackbarError(error, true);
  }
};
